import axios from "axios";
import { getAPIConfig } from "../authentication/services/get-api-config";

const API_URL = `${process.env.REACT_APP_API_URL}/v1/reviews/product`;

export interface ProductReview {
  _id: string;
  userName: string;
  rating: number;
  comment: string;
  createdAt: string;
}

export interface ProductReviewResponse {
  reviews: ProductReview[];
  summary: {
    average: number;
    count: number;
  };
}

export const getProductReviews = async (slug: string): Promise<ProductReviewResponse> => {
  const response = await axios.get(`${API_URL}/${encodeURIComponent(slug)}`);
  return response.data.data;
};

export const createProductReview = async (
  slug: string,
  payload: { rating: number; comment: string },
): Promise<ProductReview> => {
  const response = await axios.post(
    `${API_URL}/${encodeURIComponent(slug)}`,
    payload,
    await getAPIConfig(),
  );
  return response.data.data;
};
